import type { LocalProfile } from "./auth-types";

/**
 * Target route after Google OAuth. Holodeck: returning users with enrollments go straight to
 * `/lessons` or `/teacher`; archived-only students → `/no-active-classes`.
 * Replace with an authenticated session API when the gateway exists.
 */
export function resolvePostLoginRoute(profile: LocalProfile): string {
  if (profile.role === "pending") return "/onboarding";
  if (profile.role === "student" && profile.enrollmentSummary === "archived_only") {
    return "/no-active-classes";
  }
  if (profile.role === "teacher") return "/teacher";
  return "/lessons";
}
